import { createGenericSlice } from '../../../../../utils/slices'
import { DEFAULT_JOBSETTINGS_STATE } from '../../../common/constants'

const initialState = { ...DEFAULT_JOBSETTINGS_STATE }

export const jobSettingsSlice = createGenericSlice({
  name: 'jobSettings',
  initialState,
})

export const jobSettingsActions = jobSettingsSlice.actions
